module.exports = __webpack_public_path__ + "img/18.2be5cb11.jpg";